/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import ICONS from "../../../../assets/Icons";
import BeneTransactionStepAccount from "../../../../components/Transactions/BeneTrasnaction/BeneTransactionCreate/BeneTransactionStepAccount";
import BeneTransactionStepAdditionalDetails from "../../../../components/Transactions/BeneTrasnaction/BeneTransactionCreate/BeneTransactionStepAdditionalDetails";
import BeneTransactionStepAmount from "../../../../components/Transactions/BeneTrasnaction/BeneTransactionCreate/BeneTransactionStepAmount";
import BeneTransactionStepConfirm from "../../../../components/Transactions/BeneTrasnaction/BeneTransactionCreate/BeneTransactionStepConfirm";
import BeneficiaryRecreateTxnStepAdditionalDetails from "../../../../components/Transactions/BeneTrasnaction/BeneTransactionRecreate/BeneficiaryRecreateTxnStepAdditionalDetails";
import BeneficiaryRecreateTxnStepAmountPaymentMethod from "../../../../components/Transactions/BeneTrasnaction/BeneTransactionRecreate/BeneficiaryRecreateTxnStepAmountPaymentMethod";
import BeneficiaryRecreateTxnStepSourceDestination from "../../../../components/Transactions/BeneTrasnaction/BeneTransactionRecreate/BeneficiaryRecreateTxnStepSourceDestination";
import AmountToWords from "../../../../components/_utils/AmountToWords";
import PrimaryStepper from "../../../../components/_utils/CommonSteppers/PrimaryStepper";
import CommonToast from "../../../../components/_utils/CommonToast";
import SVGComponent from "../../../../components/_utils/SVGComponent";
import {
  beneBankLookUp,
  beneCategories,
  uploadImages,
} from "../../../../redux/features/beneficiary/beneAllVerification/beneAllVerification";
import {
  beneCreateTxn,
  refactorBeneficiaryTxn,
} from "../../../../redux/features/beneficiary/beneTxnAccounts/beneTransactionAccounts";
import {
  beneTxnAccountDetail,
  beneTxnViewAllAcc,
} from "../../../../redux/features/beneficiary/beneTxnViewAccData/beneTxnViewAccData";
import { beneLookUp } from "../../../../redux/features/verifyPAN/verifyPAN";
import {
  GlobalConfiguration,
  IntervalConfiguration,
  PaginationConfiguration,
} from "../../../../utils/configurationProvider";
import TEXT from "../../../../utils/globalText";
import "./index.css";

const BeneficiaryTransactionCreate = () => {
  const refactoredTxn = JSON.parse(sessionStorage.getItem("recreate_ben"));

  const steps = [
    TEXT?.SOURCE_AND_DESTINATION_ACCOUNT,
    TEXT?.ADDITIONAL_DETAILS_AND_LABELS,
    TEXT?.TRANSFER_AMOUNT,
    TEXT?.CONFIRM_AND_CREATE,
  ];

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const scrollIt = useRef(null);
  const prevBeneAccountRef = useRef(null);
  const hasAutoFillInteracted = useRef(false);
  const currentAccountDetails = location?.state;
  const [endDate, setEndDate] = useState({});
  const [isNeft, setIsNeft] = useState(true);
  const [isRtgs, setIsRtgs] = useState(false);
  const [timeData, setTimeData] = useState({});
  const [catShow, setCatShow] = useState(false);
  const [openBar, setOpenBar] = useState(false);
  const [startDate, setStartDate] = useState({});
  const [mapingCat, setMapingCat] = useState("");
  const [autoFill, setAutoFill] = useState(false);
  const [activeStep, setActiveStep] = useState(0);
  const [hyperLinks, setHyperLinks] = useState({});
  const [mapingData, setMapingData] = useState("");
  const [quantities, setQuantities] = useState({});
  const [labelsAcc, setLabelsAcc] = useState(null);
  const [direction, setDirection] = useState(null);
  const [catSelect, setCatSelect] = useState(false);
  const [openOwner, setOpenOwner] = useState(false);
  const [txnLoading, settxnLoading] = useState(false);
  const [startDateCal, setStartDateCal] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState({});
  const [previewImages, setPreviewImages] = useState({});
  const [selectedValue, setSelectedValue] = useState({});
  const [reCreateFlow, setReCreateFlow] = useState(false);
  const [sourceSelect, setSourceSelect] = useState(false);
  const [additionalData, setAdditionalData] = useState({});
  const [accountSelect, setAccountSelect] = useState(false);
  const [isNextEnabled, setIsNextEnabled] = useState(false);
  const [amountApplied, setAmountApplied] = useState(false);
  const [isConfidential, setIsConfidential] = useState(false);
  const [removeClassName, setRemoveClassName] = useState(true);
  const [isButtonDisabled, setButtonDisabled] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedValueMonth, setSelectedValueMonth] = useState({});
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 800);
  const [isAutoFilledSource, setIsAutoFilledSource] = useState(false);
  const [transactionDisable, setTransactionDisable] = useState(false);
  const [isAmountAutoFilled, setIsAmountAutoFilled] = useState(false);
  const [isMethodAutoFilled, setIsMethodAutoFilled] = useState(false);
  const [isStepper, setIsStepper] = useState(window.innerWidth <= 800);
  const [hasUserSelectedAccount, setHasUserSelectedAccount] = useState(false);
  const [initialRefactorAdditionalDetail, setInitialRefactorAdditionalDetail] =
    useState({});
  const [showSimilarModal, setShowSimilarModal] = useState(false);
  const [similarTransaction, setSimilarTransaction] = useState(false);
  const [copyData, setCopyData] = useState({
    title: "",
    data_type: "",
    value: "",
  });
  const [txnPayLoad, setTxnPayLoad] = useState({
    bankAccountName: currentAccountDetails?.name
      ? currentAccountDetails.name
      : "",
    beneAccountId: currentAccountDetails?.id ? currentAccountDetails?.id : "",
    bankAccountIFSC: currentAccountDetails?.ifsc_code
      ? currentAccountDetails?.ifsc_code
      : "",
    bankAccountNo: currentAccountDetails?.bank_acc_no
      ? currentAccountDetails?.bank_acc_no
      : "",
    categories: currentAccountDetails?.category
      ? currentAccountDetails?.category
      : "",
    amount: "",
    settleType: "",
    bankLogo: currentAccountDetails?.bank_name
      ? currentAccountDetails?.bank_name
      : "",
    pan: currentAccountDetails?.pan ? currentAccountDetails?.pan : "",
    ownerId: null,
    ownerAccountName: "",
    ownerBankIFSC: null,
    ownerBankBalance: 0,
    ownerBankLogo: null,
    ownerLastUpdated: null,
    ownerBankAccountNo: null,
    selectedCategory: null,
    mergeCategory: null,
    amountInWords: "",
    labels: currentAccountDetails?.labels ? currentAccountDetails?.labels : [],
    ownerLabels: [],
  });
  const [category, setCategory] = useState(
    txnPayLoad?.categories ? txnPayLoad?.categories?.split(",") : [],
  );
  const [refactorDisplayStep, setRefactorDisplayStep] = useState(0);
  const animationClassS =
    direction === "next" ? "animate-slide-next" : "animate-slide-prev";

  const isValidHttpUrl = (url) => {
    const httpRegex =
      /^(https?:\/\/)([a-zA-Z0-9.-]+\.[a-zA-Z]{2,})(:[0-9]{1,5})?(\/.*)?$/;
    return httpRegex.test(url);
  };

  const categories = useSelector(
    (state) => state.beneAllVerification.beneTransCategories.categories,
  );

  const { beneTxnAccountData, beneTxnAccountLoading } = useSelector(
    (state) => state?.beneTxnViewAccData,
  );

  const handleCategory = (selectedCategoryData) => {
    setSelectedCategory(selectedCategoryData);
  };

  const handleKeyDown = (event) => {
    if (
      event.target.tagName === "INPUT" ||
      event.target.tagName === "TEXTAREA"
    ) {
      if (event.key === "Tab") {
        event.preventDefault();
      }
    } else if (
      event.key === "ArrowLeft" ||
      event.key === "ArrowRight" ||
      event.key === "Tab"
    ) {
      event.preventDefault();
    }
  };

  const handleCreateTransaction = async () => {
    if (transactionDisable) return;
    setTransactionDisable(true);

    let haveImage = txnPayLoad?.mergeCategory?.some((val) => {
      return val?.data_type === "upload" && val?.value !== "Not Given";
    });

    let storeData;

    let add = 0;

    if (haveImage) {
      const responseUpload = await Promise.all(
        Object.values(uploadedFiles).map((file) =>
          dispatch(uploadImages(file)),
        ),
      );
      if (responseUpload) {
        storeData = selectedCategory?.configuration?.data?.map((val) => {
          if (additionalData[val?.name]) {
            const dataValue = additionalData[val?.name];
            if (val?.data_type === "numeric") {
              const integerValue = parseInt(dataValue, 10);
              if (!isNaN(integerValue)) {
                return { ...val, value: integerValue };
              } else {
                throw new Error(
                  `Value '${dataValue}' is not a valid integer for category '${val?.name}'`,
                );
              }
            } else if (val?.data_type === "upload") {
              const { description, ...rest } = val;
              return { ...rest, value: responseUpload[add++]?.payload };
            } else if (val?.data_type === "toggle") {
              const { description, ...rest } = val;
              return { ...rest, value: dataValue };
            } else {
              return { ...val, value: dataValue };
            }
          } else if (val?.data_type === "toggle") {
            const { description, ...rest } = val;
            return { ...rest };
          }
          return val;
        });
      }
    } else {
      storeData = selectedCategory?.configuration?.data?.map((val) => {
        if (additionalData[val?.name]) {
          const dataValue = additionalData[val?.name];
          if (val?.data_type === "numeric") {
            const integerValue = parseInt(dataValue, 10);
            if (!isNaN(integerValue)) {
              return { ...val, value: integerValue };
            } else {
              throw new Error(
                `Value '${dataValue}' is not a valid integer for category '${val?.name}'`,
              );
            }
          } else if (val?.data_type === "toggle") {
            const { description, ...rest } = val;
            return { ...rest, value: dataValue };
          } else {
            return { ...val, value: dataValue };
          }
        } else if (val?.data_type === "toggle") {
          const { description, ...rest } = val;
          return { ...rest };
        }
        return val;
      });
    }

    const response1 = await dispatch(
      beneCreateTxn({
        amount: txnPayLoad.amount,
        owner_account_id: txnPayLoad.ownerId,
        beneficiary_account_id: txnPayLoad.beneAccountId,
        category: selectedCategory?.name,
        additional_data: storeData,
        payment_method: txnPayLoad.settleType.toUpperCase(),
        confidential_transaction: isConfidential,
        labels: [
          ...(txnPayLoad.labels || []),
          ...(txnPayLoad.ownerLabels || []),
        ],
      }),
    );

    if (beneCreateTxn.fulfilled.match(response1)) {
      const transactionId = response1.payload?.transaction?.[0]?.txn_id;

      if (refactoredTxn?.type === "refactorFlow") {
        await dispatch(
          refactorBeneficiaryTxn({ txn_ids: [refactoredTxn?.txn_id] }),
        );
      }
      navigate(
        `/beneficiary_transaction_dashboard/create_beneficiary_transaction/success/${transactionId}`,
      );

      setTransactionDisable(false);
      return;
    }
    sessionStorage.setItem("bene_txn_error", JSON.stringify(response1.payload));
    navigate(
      "/beneficiary_transaction_dashboard/create_beneficiary_transaction/failed",
    );

    setTransactionDisable(false);
  };

  const queryParams = () => ({
    page_no: GlobalConfiguration?.lengthCheckOne,
    page_item_count: PaginationConfiguration?.paginationSmall,
    amount: txnPayLoad?.amount,
    payment_method: txnPayLoad?.settleType?.toUpperCase(),
    beneficiary_account_id: txnPayLoad?.beneAccountId,
    owner_account_id: txnPayLoad?.ownerId,
    confidential_transaction: isConfidential
      ? "Show only confidential"
      : !isConfidential
        ? "Hide confidential"
        : undefined,
  });

  const handleCopyLabels = (prevLabels) => {
    const currentOwnerLabels = txnPayLoad?.ownerLabels || [];

    const newOwnerLabels = prevLabels.filter((l) =>
      currentOwnerLabels.includes(l),
    );
    const newOtherLabels = prevLabels.filter(
      (l) => !currentOwnerLabels.includes(l),
    );

    setTxnPayLoad((prev) => ({
      ...prev,
      labels: newOtherLabels,
      ownerLabels: newOwnerLabels,
    }));
  };

  const handleNext = async () => {
    hasAutoFillInteracted.current = false;
    if (isButtonDisabled) return;
    setButtonDisabled(true);
    try {
      if (activeStep === GlobalConfiguration.lengthCheckTwo) {
        settxnLoading(true);
        const res = await dispatch(beneTxnViewAllAcc(queryParams()));
        const hasDuplicates =
          res?.payload?.transactions?.length >
          GlobalConfiguration?.lengthCheckZero;

        setSimilarTransaction(hasDuplicates);

        if (hasDuplicates) {
          toast.dismiss();
          CommonToast({
            text: "Few issues found click check to view.",
            icon: ICONS?.INFO_FILLED,
            variant: "var(--error)",
            btnProps: {
              isDisabled: false,
              enabledTextColor: "var(--text-primary)",
              enabledBgColor: "var(--primary-bg)",
            },
          });
        }
        setActiveStep((prev) => prev + GlobalConfiguration.lengthCheckOne);

        setDirection("next");
        settxnLoading(false);
        setRemoveClassName(false);
        setAutoFill(false);
        setTimeout(() => {
          setRemoveClassName(true);
        }, IntervalConfiguration?.intervalSemiMid);

        setOpenBar(false);
      } else if (activeStep === GlobalConfiguration.lengthCheckThree) {
        if (similarTransaction) {
          setShowSimilarModal(true);
        } else {
          await handleCreateTransaction();
        }
      } else {
        setActiveStep((prev) => prev + GlobalConfiguration.lengthCheckOne);

        setDirection("next");

        setRemoveClassName(false);
        setAutoFill(false);
        setTimeout(() => {
          setRemoveClassName(true);
        }, IntervalConfiguration?.intervalSemiMid);

        setTimeout(() => {
          setButtonDisabled(false);
        }, IntervalConfiguration?.intervalSmaller);
        setOpenBar(false);
      }
    } finally {
      setButtonDisabled(false);
    }
  };

  const handleBack = () => {
    hasAutoFillInteracted.current = false;
    if (isButtonDisabled) return;

    if (activeStep === 0) {
      navigate(-1);
      return;
    }
    setButtonDisabled(true);
    try {
      setActiveStep((prev) => (prev ? prev - 1 : 0));

      setDirection("previous");

      setAutoFill(false);
      setRemoveClassName(false);
      setTimeout(() => {
        setRemoveClassName(true);
      }, IntervalConfiguration?.intervalSemiMid);
      setOpenBar(false);
    } finally {
      setButtonDisabled(false);
    }
  };

  const isReminderFlow = location?.state?.flowType === "ReminderFlow";

  const commonStepperConfig = {
    previousEnableBgColor: "var(--primary-nav-act)",
    previousDisableBgColor: "var(--text-disabled)",
    previousEnableTextColor: "var(--text-primary)",
    previousHoverOption: "white",
    nextEnableBgColor: "var(--text-primary)",
    nextDisableBgColor: "var(--text-disabled)",
    nextEnableTextColor: "var(--primary-bg)",
    nextDisableTextColor: "var(--text-primary)",
    nextHoverOption: "black",
  };

  const reminderText = isReminderFlow
    ? `Reminder remark: ${location?.state?.txnDetails?.reminderRemark || "-"}`
    : "";

  const dataArray = steps.map((stepLabel, index) => {
    const isLastStep = index === steps.length - 1;
    const isTxnLoading = isLastStep && transactionDisable;
    return {
      ...commonStepperConfig,
      previousText:
        index === GlobalConfiguration.lengthCheckZero ? "Cancel" : "Previous",
      previousIsDisabled: isTxnLoading,
      nextText: isLastStep ? (similarTransaction ? "Check" : "Create") : "Next",
      nextLoaderNeeded: isLastStep,
      nextIsLoading: isTxnLoading,
      nextIsEnabled: isLastStep
        ? !transactionDisable
        : isNextEnabled && !isButtonDisabled,
      nextEnableBgColor: isLastStep
        ? similarTransaction
          ? "var(--emphasis)"
          : "var(--positive-act)"
        : "var(--text-primary)",
      nextDisableBgColor: isLastStep
        ? "var(--positive-act)"
        : "var(--text-disabled)",
      nextEnableTextColor: isLastStep
        ? "var(--text-primary)"
        : "var(--primary-bg)",
      nextDisableTextColor: isLastStep
        ? "var(--text-primary)"
        : "var(--text-primary)",
      stepperText: stepLabel,
      extraInfoSubText: reminderText,
      extraInfoShow: isReminderFlow,
    };
  });

  const renderCreateTxn = () => {
    switch (activeStep) {
      case 0:
        return (
          <BeneTransactionStepAccount
            catName={beneTxnAccountData?.transaction?.[0]?.category}
            catShow={catShow}
            setCatShow={setCatShow}
            catSelect={catSelect}
            setCatSelect={setCatSelect}
            accountSelect={accountSelect}
            setAccountSelect={setAccountSelect}
            sourceSelect={sourceSelect}
            setSourceSelect={setSourceSelect}
            mapingData={mapingData}
            setMapingData={setMapingData}
            mapingCat={mapingCat}
            category={category}
            setCategory={setCategory}
            txnPayLoad={txnPayLoad}
            setTxnPayLoad={setTxnPayLoad}
            selectedCategory={selectedCategory}
            setSelectedCategory={setSelectedCategory}
            handleCategorySelect={handleCategory}
            categories={categories}
            setAdditionalData={setAdditionalData}
            isModalOpen={isModalOpen}
            setIsModalOpen={setIsModalOpen}
            setSelectedValue={setSelectedValue}
            setSelectedValueMonth={setSelectedValueMonth}
            setStartDate={setStartDate}
            setEndDate={setEndDate}
            setStartDateCal={setStartDateCal}
            setQuantities={setQuantities}
            setHyperLink={setHyperLinks}
            setPreviewImages={setPreviewImages}
            setUploadedFiles={setUploadedFiles}
            setTimeData={setTimeData}
            setMapingCat={setMapingCat}
            labelsAcc={labelsAcc}
            setLabelsAcc={setLabelsAcc}
            openOwner={openOwner}
            setOpenOwner={setOpenOwner}
            isConfidential={isConfidential}
            setIsConfidential={setIsConfidential}
            setHasUserSelectedAccount={setHasUserSelectedAccount}
            setIsAutoFilledSource={setIsAutoFilledSource}
          />
        );
      case 1:
        return (
          <BeneTransactionStepAdditionalDetails
            txnPayLoad={txnPayLoad}
            setTxnPayLoad={setTxnPayLoad}
            additionalData={additionalData}
            setAdditionalData={setAdditionalData}
            selectedValue={selectedValue}
            setSelectedValue={setSelectedValue}
            selectedValueMonth={selectedValueMonth}
            setSelectedValueMonth={setSelectedValueMonth}
            startDate={startDate}
            setStartDate={setStartDate}
            endDate={endDate}
            setEndDate={setEndDate}
            startDateCal={startDateCal}
            setStartDateCal={setStartDateCal}
            quantities={quantities}
            setQuantities={setQuantities}
            hyperLink={hyperLinks}
            setHyperLink={setHyperLinks}
            uploadedFiles={uploadedFiles}
            setUploadedFiles={setUploadedFiles}
            previewImages={previewImages}
            setPreviewImages={setPreviewImages}
            timeData={timeData}
            setTimeData={setTimeData}
            copyData={copyData}
            setCopyData={setCopyData}
            initialRefactorAdditionalDetail={initialRefactorAdditionalDetail}
            setInitialRefactorAdditionalDetail={
              setInitialRefactorAdditionalDetail
            }
          />
        );
      case 2:
        return (
          <BeneTransactionStepAmount
            txnPayLoad={txnPayLoad}
            setTxnPayLoad={setTxnPayLoad}
            isNeft={isNeft}
            setIsNeft={setIsNeft}
            isRtgs={isRtgs}
            setIsRtgs={setIsRtgs}
            amountInWords={txnPayLoad.amountInWords}
            copyData={copyData}
            setCopyData={setCopyData}
            txnLoading={txnLoading}
          />
        );
      case 3:
        return (
          <BeneTransactionStepConfirm
            txnPayLoad={txnPayLoad}
            setTxnPayLoad={setTxnPayLoad}
            isConfidential={isConfidential}
            previewImages={previewImages}
            showSimilarModal={showSimilarModal}
            setShowSimilarModal={setShowSimilarModal}
            queryParams={queryParams()}
            onForceCreate={handleCreateTransaction}
            isReminderFlow={isReminderFlow}
          />
        );
      default:
        return null;
    }
  };

  const renderRefactorSteps = (stepOverride) => {
    const step = stepOverride ?? activeStep;
    switch (step) {
      case 0:
        return (
          <BeneficiaryRecreateTxnStepSourceDestination
            catShow={catShow}
            accountSelect={accountSelect}
            setAccountSelect={setAccountSelect}
            sourceSelect={sourceSelect}
            setSourceSelect={setSourceSelect}
            catSelect={catSelect}
            setCatSelect={setCatSelect}
            beneName={
              beneTxnAccountData?.transaction?.[0]?.beneficiary_account_name
            }
            beneCat={beneTxnAccountData?.transaction?.[0]?.category}
            setMapingCat={setMapingCat}
            setMapingData={setMapingData}
            activeStep={activeStep}
            beneTxnAccountData={beneTxnAccountData}
            OwnerAcctName={
              beneTxnAccountData?.transaction?.[0]?.owner_account_bank_acc_no
            }
            txnPayload={txnPayLoad}
            setTxnPayLoad={setTxnPayLoad}
            setIsNeft={setIsNeft}
            setIsConfidential={setIsConfidential}
            isConfidential={isConfidential}
            categories={categories}
            category={category}
            isAutoFilledSource={isAutoFilledSource}
            setIsAutoFilledSource={setIsAutoFilledSource}
            selectedCategory={selectedCategory}
          />
        );

      case 1:
        return (
          <BeneficiaryRecreateTxnStepAdditionalDetails
            txnPayLoad={txnPayLoad}
            onCopyLabels={handleCopyLabels}
            beneTxnAccountData={beneTxnAccountData}
            initialRefactorAdditionalDetail={initialRefactorAdditionalDetail}
            setInitialRefactorAdditionalDetail={
              setInitialRefactorAdditionalDetail
            }
            setSelectedValue={setSelectedValue}
            setSelectedValueMonth={setSelectedValueMonth}
            setStartDateCal={setStartDateCal}
            setStartDate={setStartDate}
            setEndDate={setEndDate}
            setTimeData={setTimeData}
            additionalData={additionalData}
            setAdditionalData={setAdditionalData}
            setQuantities={setQuantities}
          />
        );

      case 2:
        return (
          <BeneficiaryRecreateTxnStepAmountPaymentMethod
            beneTxnAccountData={beneTxnAccountData}
            amountApplied={amountApplied}
            setAmountApplied={setAmountApplied}
            txnPayLoad={txnPayLoad}
            setTxnPayLoad={setTxnPayLoad}
            setIsNeft={setIsNeft}
            setIsRtgs={setIsRtgs}
            isNeft={isNeft}
            isRtgs={isRtgs}
            copyData={copyData}
            setCopyData={setCopyData}
            setIsAmountAutoFilled={setIsAmountAutoFilled}
            isAmountAutoFilled={isAmountAutoFilled}
            setIsMethodAutoFilled={setIsMethodAutoFilled}
            isMethodAutoFilled={isMethodAutoFilled}
          />
        );

      default:
        return null;
    }
  };

  let operBarValidation = useCallback(() => {
    return (
      (!isModalOpen && activeStep === 0) ||
      (!openOwner && activeStep === 2) ||
      activeStep === 1 ||
      activeStep === 3
    );
  }, [openOwner, isModalOpen, activeStep]);

  useEffect(() => {
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 800) {
        setReCreateFlow(false);
      }
    };
    handleResize();

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    if (refactoredTxn?.txn_id) {
      dispatch(beneTxnAccountDetail(refactoredTxn?.txn_id));
    }
  }, []);

  useEffect(() => {
    if (!beneTxnAccountLoading) {
      const initalData = {};

      const additionalData =
        beneTxnAccountData?.transaction?.[0]?.additional_data?.data || [];

      additionalData?.forEach(({ name, value, data_type }) => {
        if (
          value !== null &&
          value !== "" &&
          value !== undefined &&
          value?.length !== GlobalConfiguration?.lengthCheckZero
        ) {
          if (
            data_type === "hyperlink" ||
            data_type === "string" ||
            data_type === "numeric"
          ) {
            initalData[name] = {
              isCopyClick: false,
              isPaste: {},
              name: name,
              data: value,
            };
          } else {
            initalData[name] = {
              isCopyDirect: false,
              name: name,
              data: value,
            };
          }
        }
      });
      setInitialRefactorAdditionalDetail(initalData);
    }
  }, [beneTxnAccountData, beneTxnAccountLoading]);

  useEffect(() => {
    const configData = txnPayLoad?.selectedCategory?.configuration?.data || [];
    const mergeCategory = txnPayLoad?.mergeCategory || [];

    const mandatoryFields = configData.filter((v) => v?.mandatory === "Y");

    const filledMandatoryFields = mergeCategory.filter((v) => {
      if (v?.mandatory !== "Y") return false;

      switch (v?.data_type) {
        case "multi_select_list":
          return Array.isArray(v.value) && v.value.length > 0;

        case "from_year_to_year": {
          const from = v?.value?.from;
          const to = v?.value?.to;

          const bothEmpty = !from && !to;
          const bothFilled = from && to;

          if (bothEmpty && v?.mandatory !== "Y") {
            return true;
          }

          return bothFilled;
        }

        case "date_range":
          return v?.value?.start_date && v?.value?.end_date;

        case "toggle":
          return v?.value === true;

        // case "upload":
        //   return !!v?.value;

        default:
          return v?.value !== "" && v?.value !== undefined;
      }
    });

    const isMandatoryFieldsFilled =
      mandatoryFields.length === filledMandatoryFields.length;

    const isHyperlinkHave = mergeCategory.some(
      (v) => v?.data_type === "hyperlink",
    );

    const isHyperlinkValid = mergeCategory
      .filter((v) => v?.data_type === "hyperlink" && v?.value !== "")
      .every((v) => isValidHttpUrl(v?.value));

    const isAmountValid = txnPayLoad?.amount > 0;

    const isRtgsSelected = txnPayLoad?.settleType === "rtgs";
    const isRtgsValid = !isRtgsSelected || txnPayLoad?.amount >= 200000;

    const isSettleTypeValid =
      txnPayLoad?.settleType &&
      !(
        (txnPayLoad?.settleType === "imps" && txnPayLoad?.amount > 200000) ||
        (txnPayLoad?.settleType === "rtgs" && txnPayLoad?.amount <= 200000) ||
        (txnPayLoad?.settleType === "neft" && txnPayLoad?.amount > 200000)
      );

    let isStepValid = false;

    switch (activeStep) {
      case 0:
        isStepValid =
          !!txnPayLoad?.ownerId &&
          !!txnPayLoad?.beneAccountId &&
          !!txnPayLoad?.selectedCategory;
        break;

      case 1:
        isStepValid =
          isMandatoryFieldsFilled && (!isHyperlinkHave || isHyperlinkValid);
        break;

      case 2:
        isStepValid = isAmountValid && isRtgsValid && isSettleTypeValid;
        break;

      case 3:
        isStepValid = true;
        break;

      default:
        isStepValid = false;
    }
    setIsNextEnabled(isStepValid);
  }, [activeStep, txnPayLoad, hyperLinks]);

  useEffect(() => {
    if (
      location?.state?.txnDetails?.reminderAmount &&
      txnPayLoad?.amount === ""
    ) {
      const amount = parseFloat(location.state.txnDetails.reminderAmount);

      let words = AmountToWords(amount) || "";

      if (amount >= 1 && amount <= 9) {
        words = words.replace("rupees", "rupee");
      }

      setTxnPayLoad((prev) => ({
        ...prev,
        amount: amount,
        amountInWords: words,
      }));
    }
  }, [location]);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= 800;

      setIsMobile(mobile);
      setIsStepper(mobile);

      if (!mobile) {
        setAutoFill(false);
      }
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    const { beneAccountId, pan, bankAccountIFSC, bankAccountNo } =
      txnPayLoad || {};

    if (!beneAccountId) return;
    if (!hasUserSelectedAccount) return;
    if (prevBeneAccountRef.current === beneAccountId) return;

    prevBeneAccountRef.current = beneAccountId;

    dispatch(beneCategories({ bene_account_id: beneAccountId }));

    if (pan) {
      dispatch(beneLookUp({ pan_number: pan }));
    }

    if (bankAccountIFSC && bankAccountNo) {
      dispatch(
        beneBankLookUp({
          ifsc: bankAccountIFSC,
          bank_account_no: bankAccountNo,
        }),
      );
    }
  }, [txnPayLoad?.beneAccountId, hasUserSelectedAccount]);

  return (
    <div
      className="w-width-full flex justify-start items-center flex-col bg-primary-bg overflow-y-auto"
      style={{
        height:
          openOwner || isModalOpen
            ? "var(--height-full)"
            : "var(--full-height)",
      }}
    >
      <div className="w-width-full hidden Qsmd:block h-navbar-breadcrumb-height Qlg:bg-transparent bg-primary-nav flex-shrink-0"></div>
      <div
        className={`fixed Qsmd:relative left-left-base z-z-index-loader flex justify-center items-center flex-col lg:flex-col-reverse w-width-full lg:py-padding-base bottom-bottom-base top-auto lg:top-top-base lg:bottom-auto Qsmd:bg-transparent
         ${location?.state?.flowType === "ReminderFlow" ? "Qsmd:min-h-topnav-bottom-height min-h-stepper-height" : refactoredTxn?.type === "refactorFlow" ? "Qsmd:min-h-[calc(var(--stepper-height)+var(--icon-sm))] min-h-stepper-height  Qsmd:bg-transparent" : "Qsmd:min-h-[calc(var(--stepper-height)+var(--icon-sm))] min-h-stepper-height  Qsmd:bg-transparent"}`}
      >
        {location?.state?.flowType === "ReminderFlow" && (
          <div
            className={`${openBar && isStepper ? "none" : ""} stepper_Div w-width-full  Qsmd:hidden`}
            style={{
              width: isMobile ? "var(--full-width)" : "",
            }}
          >
            <div className="reminder-bene-flow-container bg-primary-card Qsmd:relative z-z-index-header rounded-br-border-radius-md rounded-bl-border-radius-md fixed">
              <div
                className={`transition-[max-height] duration-animation-medium ease-in-out ${
                  openBar
                    ? "max-h-max-height-top-slider opacity-base-opacity pointer-events-auto"
                    : "max-h-0 opacity-opacity-none pointer-events-none "
                } overflow-hidden`}
                style={{
                  zIndex: openBar
                    ? "var(--z-index-content)"
                    : "var(--z-index-base)",
                }}
              >
                <section className="reminder-flow-message-container">
                  <span className="text-font-xs text-text-primary font-sans Qsmd:hidden">
                    Reminder remark
                  </span>
                  <p
                    className={`text-font-xs text-text-primary font-sans font-normal pt-padding-sm Qsmd:pt-padding-base`}
                  >
                    {location?.state?.txnDetails?.reminderRemark}
                  </p>
                </section>

                <hr className="hidden w-max-content-width Qsmd:block border border-primary-bg" />
              </div>

              {openBar && (
                <button
                  className="w-full h-auto flex items-center justify-center bg-text-primary cursor-pointer z-z-index-toast py-padding-sm fixed bottom-bottom-base left-left-base Qsmd:hidden transition-all duration-animation-medium ease-in-out"
                  onClick={() => setOpenBar(false)}
                >
                  <span className="text-font-md font-sans font-semibold text-primary-card">
                    Back
                  </span>
                </button>
              )}

              <section
                className={`w-full Qmd:p-padding-sm p-padding-md  Qsmd:bg-primary-card flex flex-row Qsmd:justify-center Qmd:rounded-br-border-radius-md Qmd:rounded-bl-border-radius-md items-center gap-gap-sm bg-primary-nav-act justify-between z-z-index-base relative bottom-bottom-sm  cursor-${
                  operBarValidation() ? "pointer" : ""
                } hover:${operBarValidation() ? "bg-primary-card" : ""} ${
                  operBarValidation() ? "global-hover-white" : ""
                }`}
                onClick={() => {
                  if (operBarValidation()) {
                    setOpenBar(!openBar);
                  }
                }}
              >
                <span className="text-font-xs text-text-primary font-sans font-normal">
                  Reminder remark
                </span>

                <div
                  className={`transition-transform duration-animation-medium ease-in-out `}
                >
                  <SVGComponent
                    url={
                      isMobile
                        ? openBar
                          ? ICONS?.ARROW_UP_WHITE
                          : ICONS?.ARROW_RIGHT_WHITE
                        : openBar
                          ? ICONS?.ARROW_UP_WHITE
                          : ICONS?.ARROW_DOWN_WHITE
                    }
                    color="var(--text-primary)"
                    height={"var(--icon-sm)"}
                    width={"var(--icon-sm)"}
                  />
                </div>
              </section>
            </div>
          </div>
        )}
        {isStepper && refactoredTxn?.type === "refactorFlow" && (
          <div className="fixed bottom-bottom-base w-width-full">
            <div
              style={{
                display: activeStep === 3 ? "none" : "block",
              }}
              className="Refactor_responsive_Bottomdiv w-width-full bg-primary-nav-act p-padding-md relative global-hover-white z-z-index-base cursor-pointer"
              onClick={() => {
                setReCreateFlow(true);
              }}
            >
              <div className="flex justify-between">
                <p className="font-semibold text-text-primary text-font-xs">
                  Copy or autofill from previous transactions details
                </p>
                <div className="">
                  <SVGComponent
                    url={ICONS?.ARROW_RIGHT_WHITE}
                    color={"var(--text-primary)"}
                    height={"var(--icon-sm)"}
                    width={"var(--icon-sm)"}
                    alt="Arrow"
                  />
                </div>
              </div>
            </div>
            <div className="h-stepper-moble-height w-width-full block Qmd:hidden flex-shrink bg-primary-nav-act"></div>
          </div>
        )}

        {reCreateFlow && (
          <div className="fixed top-top-base left-left-base w-width-full h-height-full bg-primary-bg flex z-[9998] translate-y-0 ease-in-out">
            <div className="flex items-center w-[100vw] bg-primary-nav px-padding-md py-padding-sm rounded-b-border-radius-sm fixed top-top-base z-20">
              <div
                className="cursor-pointer flex-shrink-0"
                onClick={() => {
                  setReCreateFlow(false);
                }}
              >
                <SVGComponent
                  url={ICONS?.ARROW_LEFT_WHITE}
                  color={"var(--text-primary)"}
                  height={"var(--icon-md)"}
                  width={"var(--icon-md)"}
                  alt="Arrow"
                />
              </div>
              <div className="flex flex-col gap-gap-xs w-full-width bg-primary-nav pl-padding-md">
                <div className="text-text-primary text-base font-semibold">
                  Create transaction
                </div>
                <p className="text-text-primary text-xs">
                  Previous transaction details
                </p>
              </div>
            </div>
            <>{renderRefactorSteps(refactorDisplayStep)}</>
          </div>
        )}

        <PrimaryStepper
          activeStep={activeStep}
          handleForwardAction={handleNext}
          handleBackwardAction={handleBack}
          dataArray={dataArray}
        />
      </div>
      <div
        className={`w-width-full rounded-b-border-radius-md lg:max-w-tab-width-normal relative group top-[calc(var(--negative-global-var)*var(--padding-md))] ${refactoredTxn?.type === "refactorFlow" ? "Qsmd:mb-[calc(var(--negative-global-var)*var(--margin-md))]" : ""}`}
      >
        <div className="lg:h-stepper-header qmd:block hidden"></div>{" "}
        {refactoredTxn?.type === "refactorFlow" ? (
          <div
            className={`Qmd:block hidden relative w-width-full py-padding-sm bg-primary-card max-w-tab-width-normal z-z-index-base ${!autoFill ? "group-hover:bg-primary-nav-act" : ""}  ${activeStep === 3 ? "rounded-b-border-radius-md" : ""}`}
          ></div>
        ) : (
          <></>
        )}
        <div
          className={`w-width-full bg-primary-card relative group lg:max-w-tab-width-normal rounded-b-border-radius-md ${refactoredTxn?.type === "refactorFlow" ? "mt-margin-base" : " Qmd:mt-margin-base"}`}
          style={{
            display: isMobile || activeStep === 3 ? "none" : "flex",
            justifyContent: "center",
            height: autoFill
              ? " auto"
              : refactoredTxn?.type !== "refactorFlow"
                ? "var(--height-base)"
                : "",
          }}
        >
          <div
            className={`flex w-width-full ${autoFill ? "items-end" : "items-center pb-padding-base"} ${refactoredTxn?.type !== "refactorFlow" ? "hidden" : ""}`}
          >
            <div className="flex flex-col w-width-full">
              {/* {autoFill && ( */}
              <div
                className={`flex w-width-full ${refactorDisplayStep === GlobalConfiguration?.lengthCheckOne ? "pl-padding-md" : "px-padding-md"} justify-between`}
                // className="flex justify-between w-width-full px-padding-md"
                style={{
                  // overflowY: "scroll",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <div
                  className={`autofill-wrapper w-width-full !hidden Qmd:!flex ${
                    !hasAutoFillInteracted.current
                      ? ""
                      : autoFill
                        ? "openWrap"
                        : "closeWrap"
                  }`}
                  onAnimationEnd={() => {
                    if (!autoFill) {
                      setRefactorDisplayStep(activeStep);
                    }
                  }}
                >
                  {renderRefactorSteps(refactorDisplayStep)}
                </div>
              </div>
              {/* )} */}
              {autoFill && (
                <div className="border border-primary-bg mx-margin-md"></div>
              )}
              <div
                className="flex items-center justify-center gap-gap-xs py-padding-sm rounded-b-border-radius-md relative global-hover-white z-z-index-base cursor-pointer"
                onClick={() => {
                  hasAutoFillInteracted.current = true;
                  if (!autoFill) {
                    setRefactorDisplayStep(activeStep);
                  }
                  setAutoFill(!autoFill);
                }}
              >
                <p className="text-text-primary text-sm mr-margin-xs cursor-pointer">
                  Copy or autofill from previous transactions details
                </p>

                <div className="">
                  <SVGComponent
                    url={
                      autoFill ? ICONS?.ARROW_UP_WHITE : ICONS?.ARROW_DOWN_WHITE
                    }
                    alt="auto fill"
                    color={"var(--text-primary)"}
                    height={"var(--icon-sm)"}
                    width={"var(--icon-sm)"}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {isStepper && (
        <>
          <div className="flex items-center w-full-width h-mobile-create-header bg-primary-nav px-padding-md py-padding-sm top-top-base z-z-index-header shadow-box-shadow-bottom rounded-b-border-radius-sm">
            <div
              className="cursor-pointer"
              onClick={() => {
                if (openBar) {
                  setOpenBar(false);
                } else if (activeStep === 0) {
                  navigate("/beneficiary_transaction_dashboard");
                } else {
                  navigate(-1);
                }
              }}
            >
              <SVGComponent
                url={ICONS?.ARROW_LEFT_WHITE}
                color={"var(--text-primary)"}
                height={"var(--icon-md)"}
                width={"var(--icon-md)"}
                alt="Arrow"
              />
            </div>
            <div className="flex flex-col gap-gap-xs ml-margin-md">
              <div className="text-text-primary text-base">
                Beneficiary transaction
              </div>

              {reCreateFlow ? (
                <>
                  <p className="text-text-primary text-xs font-semibold">
                    Previous transaction details
                  </p>
                </>
              ) : (
                <>
                  <div className="text-text-secondary text-xs">
                    {steps[activeStep] || ""}
                  </div>
                </>
              )}
            </div>
          </div>
        </>
      )}
      <div
        className="overflow-hidden h-full flex flex-col items-center relative w-width-full"
        ref={scrollIt}
      >
        <>
          <div
            className={`w-width-full h-height-full mb-margin-base overflow-y-auto ${
              activeStep === 0 && direction === "next"
                ? ""
                : removeClassName === true
                  ? ""
                  : animationClassS
            }`}
          >
            {renderCreateTxn()}
          </div>
          {reCreateFlow ||
            (activeStep === 0 && (
              <>
                <div className="h-mobile-create-header flex-shrink-0 block Qsmd:hidden"></div>
              </>
            ))}
        </>
      </div>
    </div>
  );
};

export default BeneficiaryTransactionCreate;
